import type { ComponentTheme } from '../types/component-theme';

import { softPanelSurfaceStyles } from '../shared-styles';

export default {
    slots: {
        root: 'grid overflow-hidden',
        content: 'min-h-0 overflow-hidden',
        form: `mt-3 ${softPanelSurfaceStyles} p-4 shadow-(--panel-shadow-soft-inset)`,
        actions: 'mt-4 grid grid-cols-1 gap-2 sm:grid-cols-[auto_auto] sm:justify-end desk:flex desk:justify-end',
        button:
            'w-full justify-center max-desk:h-8 max-desk:rounded-full max-desk:px-3! max-desk:py-0! ' +
            'max-desk:font-semibold desk:w-auto',
        lightText:
            'max-desk:text-[0.625rem] bg-none! text-(--text-button-light)! ' +
            '[-webkit-text-fill-color:var(--text-button-light)]',
        darkText:
            'max-desk:text-[0.625rem] bg-none! text-(--white-alpha-95)! ' +
            '[-webkit-text-fill-color:var(--white-alpha-95)]'
    }
} satisfies ComponentTheme;
